<template>


  <div>


    <v-alert type="info" v-if="syncStatus.length == 0" class="ma-0">
      {{ $t('erp.widgets.sync_queue.no_outstanding_sync') }}
    </v-alert>


    <div v-else>

      <v-container class="my-0 pa-3">

        <v-row>
          <v-col md="6" class="d-flex flex-column ma-0" v-for="shop in shops" :key="shop">
            <v-card flat class="flex d-flex flex-column">

              <v-card-text>

                <v-toolbar flat dense>
                  <v-toolbar-title>{{ shop }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-chip label>{{ getShopEventTotal(shop) }}</v-chip>
                </v-toolbar>

                <v-simple-table>


                  <tbody>

                  <tr v-for="event in getShopEvents(shop)" :key="event.event_type">

                    <td>

                       <span v-if="event.event_type == 'product.full'">

                            <v-icon>mdi-package-variant-closed</v-icon>
                           {{ $t('widget.sync_queue.product_full') }}

                       </span>
                      <span v-else-if="event.event_type == 'product.stock'">

                            <v-icon>mdi-package-down</v-icon>
                           {{ $t('widget.sync_queue.product_stock') }}

                       </span>
                      <span v-else-if="event.event_type == 'product.price'">

                            <v-icon>mdi-currency-eur</v-icon>
                           {{ $t('widget.sync_queue.product_price') }}

                       </span>

                      <span v-else-if="event.event_type == 'order.transition'">

                              <v-icon>mdi-currency-eur</v-icon>
                           {{ $t('widget.sync_queue.order_transition') }}

                       </span>

                      <span v-else-if="event.event_type == 'order.refund'">

                              <v-icon>mdi-credit-card-refund</v-icon>
                           {{ $t('widget.sync_queue.order_refund') }}

                       </span>

                      <span v-else-if="event.event_type == 'customer.full'">

                              <v-icon>mdi-account</v-icon>
                           {{ $t('widget.sync_queue.customer_full') }}

                       </span>

                      <span v-else-if="event.event_type == 'customer.delete'">

                              <v-icon>mdi-account-cancel</v-icon>
                           {{ $t('widget.sync_queue.customer_delete') }}

                       </span>

                      <span v-else-if="event.event_type == 'email'">

                              <v-icon>mdi-email-send</v-icon>
                              {{ $t('widget.sync_queue.email') }}

                       </span>

                      <span v-else-if="event.event_type == 'shop.products'">

                            <v-icon>mdi-sync-circle</v-icon>
                           {{ $t('widget.sync_queue.shop_product_full') }}

                       </span>

                      <span v-else>
                            <v-icon>mdi-sync-circle</v-icon>
                           {{ event.event_type }}
                       </span>

                    </td>
                    <td style="width:30px;" class="text-right">
                      <v-chip label small>{{ event.quantity }}</v-chip>
                    </td>

                  </tr>

                  </tbody>


                </v-simple-table>

              </v-card-text>

            </v-card>
          </v-col>
        </v-row>

      </v-container>


    </div>


  </div>


</template>


<script>


export default {


  name: 'syncQueueWidget.vue',
  wconf: {

    title: 'dashboard.widget.title.sync_queue',
    location: 'primary',
    position: 30,
    active: true,
    roles: ['admin']

  },

  data() {

    return {

      syncStatus: [],
      interval: null,

    }

  },


  methods: {


    getTitle() {

      return this.$t('dashboard.widget.title.sync_queue')

    },

    getShopEvents(shop_name) {


      return this.syncStatus.filter(line => line.shop_name == shop_name);


    },

    getShopEventTotal(shop_name) {


      let quantity = 0;
      let events = this.getShopEvents(shop_name);


      for (let i = 0; i < events.length; i++) {


        quantity += parseInt(events[i].quantity);

      }


      return quantity;

    },

    getStatus: function () {


      var self = this;

      self.$http.get('api/erp/v2/info/sync-status').then((result) => {


        self.syncStatus = result.data.payload;


      });


    }

  },

  computed: {


    shops: function () {

      let columnName = 'shop_name';

      let shops = this.syncStatus.map(function (value, index) {
        return value[columnName];
      })


      let unique_shops = [];


      for (let i = 0; i < shops.length; i++) {


        if (unique_shops.indexOf(shops[i]) == -1) {

          unique_shops.push(shops[i]);

        }

      }

      return unique_shops;

    },


  },

  destroyed: function () {

    let self = this;
    clearInterval(self.interval);


  },

  mounted: function () {


    var self = this;


    self.getStatus();

    self.interval = setInterval(function () {
      self.getStatus()
    }, 5000);


  },
  created() {
  }


}


</script>